import { Avatar } from '@fluentui/react-components';

// Common Function
import * as CommonFunction from '../../../../functions/common';
import './HeaderPersonaComponent.css';

export type PersonaSize = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge';

export interface IProps {
  PersonImage?: string | undefined;
  PersonaName: string;
  secondaryText?: string;
  size?: PersonaSize;
}

const AVATAR_SIZE: Record<PersonaSize, 24 | 28 | 36 | 40 | 56 | 64> = {
  'extra-small': 24,
  'small': 28,
  'medium': 36,
  'large': 40,
  'extra-large': 56,
  'huge': 64,
};

export const HeaderPersonaComponent = (props: IProps) => {
  const size = props.size ?? 'huge';
  const avatarPx = AVATAR_SIZE[size];

  return (
    <div className={`hp-root hp-root--${size}`}>
      <Avatar
        size={avatarPx}
        name={props.PersonaName}
        initials={CommonFunction.getNameInitials(props.PersonaName)}
        image={props.PersonImage ? { src: props.PersonImage } : undefined}
        color="brand"
      />
      <div className="hp-text">
        <span className="hp-name">{props.PersonaName}</span>
        {props.secondaryText && (
          <span className="hp-secondary">{props.secondaryText}</span>
        )}
      </div>
    </div>
  );
};
